<template>
    <div :style="cStyle">
        <hts-form-autocomplete
            :label="!noLabel ? $t('labels.nodeModule.findNodes') : ''"
            :required="required"
            :server="serverNode"
            :text="textDefault || dataFormSelectNode.name"
            :add="false"
            key-id="_id"
            key-label="name"
            key-type="type"
            :placeholder="$t('labels.nodeModule.selectNode')"
            :node-type="props.type"
            :disabled="disabled"
            @change="(data:any, dataDetail: any)=>handleChange(data, dataDetail)"
            @drag-start="(event: any) => handleActionDragStart(event)" />
    </div>
</template>
<script lang="ts" setup>
import dataForm from '../imports/model'

const props = defineProps({
  nodeIsSelected: {
    type: Object,
    default: () => {}
  },
  type: {
    type: String,
    default: ''
  },
  required: {
    type: Boolean,
    default: false
  },
  noLabel: {
    type: Boolean,
    default: false
  },
  textChange: {
    type: String,
    default: ''
  },
  textDefault: {
    type: String,
    default: ''
  },
  disabled: {
    type: Boolean,
    default: false
  },
  size: [String, Number]
})
const { textChange, size } = toRefs(props)
watch(props, () => {
  dataFormSelectNode.name = textChange.value || ''
})
const serverNode = $urlAdmin.node.findNodes
const dataFormSelectNode = reactive({ ...dataForm.initValue })
onMounted(() => {
  Object.assign(dataFormSelectNode, { ...props.nodeIsSelected })
})
const emits = defineEmits(['changeInput', 'dragStart'])

const handleChange = (data: any, dataDetail: any) => {
  emits('changeInput', data, dataDetail)
}
const handleActionDragStart = (event: any) => {
  emits('dragStart', event)
}
const cStyle = computed(() => {
  if (size && size.value) {
    if (typeof size.value === 'number') {
      return {
        width: size.value + '%'
      }
    }
    if (typeof size.value === 'string') {
      switch (size.value) {
      case 'small':
        return { width: '20%' }
      case 'large':
        return { width: '70%' }
      case 'full':
        return { width: '100%' }
      default:
        return { width: size.value }
      }
    }
  }
  return {
    width: '40%'
  }
})
</script>
